import { translate } from '../i18n';

export const renderError = () => {
  const errorContainer = document.createElement('div');
  errorContainer.id = 'brand-registry-header-error';
  errorContainer.classList.add('tw-br-trim-flex', 'tw-br-trim-p-4', 'tw-br-trim-w-full');

  const errorIcon = document.createElement('img');
  errorIcon.classList.add('tw-br-trim-w-[20px]', 'tw-br-trim-h-[20px]', 'tw-br-trim-me-3');
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  errorIcon.src = require('../images/danger_info.svg').default;
  errorContainer.append(errorIcon);

  const alertTextContent = document.createElement('div');

  const alertHeader = document.createElement('h4');
  alertHeader.classList.add('tw-br-trim-m-0');
  alertHeader.textContent = translate('br-trim-error-message-header');
  alertTextContent.append(alertHeader);

  const alertBody = document.createElement('div');
  alertBody.classList.add('tw-br-trim-mt-1', 'tw-br-trim-flex');

  const alertBodyText = document.createElement('p');
  alertBodyText.textContent = translate('br-trim-error-message-body');
  alertBodyText.classList.add('tw-br-trim-m-0');
  alertBody.append(alertBodyText);

  alertTextContent.append(alertBody);

  errorContainer.append(alertTextContent);

  const alertBodyAction = document.createElement('div');
  alertBodyAction.classList.add('tw-br-trim-justify-items-end', 'tw-br-trim-ms-auto', 'tw-br-trim-shrink-0');

  const alertBodyActionLink = document.createElement('a');
  alertBodyActionLink.href = location.href;
  alertBodyActionLink.id = 'brand-registry-header-error-refresh-link';
  alertBodyActionLink.classList.add('tw-br-trim-flex', 'tw-br-trim-items-center');

  const alertBodyActionIcon = document.createElement('img');
  alertBodyActionIcon.classList.add('tw-br-trim-w-[20px]', 'tw-br-trim-h-[20px]', 'tw-br-trim-me-2');
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  alertBodyActionIcon.src = require('../images/refresh.svg').default;
  alertBodyActionLink.append(alertBodyActionIcon);

  const alertBodyActionText = document.createElement('span');
  alertBodyActionText.textContent = translate('br-trim-error-message-refresh-page');
  alertBodyActionLink.append(alertBodyActionText);

  alertBodyAction.append(alertBodyActionLink);

  errorContainer.append(alertBodyAction);

  return errorContainer;
};
